import {
  SearchAuditEventsRequest,
  SearchAuditEventsResponse,
} from '@weave/schema-gen-ts/dist/apis/api/phone/audits/v1/api.pb';
import { useQuery, UseQueryOptions } from 'react-query';
import { searchAuditEvents, SearchAuditEventsOptions } from './api';

export const phoneAuditsQueryKeys = {
  // Base/prefix key shared by all searchAuditEvents queries (list + detail lookups). Useful for bulk cache
  // invalidation/removal via queryClient methods that match by key prefix.
  searchAuditEventsBase: ['phone', 'audits', 'searchAuditEvents'] as const,
  // Prefix key scoped to a single phone tenant (the API itself is scoped by tenantId via the URL, e.g.
  // `/phone/audits/v1/tenants/{tenantId}/auditEvents:search`).
  searchAuditEventsByTenant: (tenantId: string) => [...phoneAuditsQueryKeys.searchAuditEventsBase, tenantId] as const,
  searchAuditEvents: (req: SearchAuditEventsRequest, baseUrl: string) => [
    ...phoneAuditsQueryKeys.searchAuditEventsByTenant(req.tenantId ?? ''),
    baseUrl,
    req,
  ],
};

export const useSearchAuditEvents = (
  req: SearchAuditEventsRequest,
  apiOptions: SearchAuditEventsOptions,
  queryOptions?: Omit<
    UseQueryOptions<SearchAuditEventsResponse, unknown, SearchAuditEventsResponse>,
    'queryKey' | 'queryFn'
  >
) => {
  return useQuery<SearchAuditEventsResponse, unknown>({
    queryKey: phoneAuditsQueryKeys.searchAuditEvents(req, apiOptions.baseUrl),
    queryFn: () => searchAuditEvents(req, apiOptions),
    ...queryOptions,
  });
};
